export class Countries {
  data = [
    { name: 'English (US)', code: 'US', language: 'en' },
    { name: 'Tiếng Việt', code: 'VN', language: 'vi' },
    // { name: 'English (UK)', code: 'UK', language: 'uk' },
  ];
}
